import { Link, useLocation } from 'react-router-dom';
import { Box, UnstyledButton, Text, Stack, Divider } from '@mantine/core';
import { IconHome, IconSearch, IconPlus, IconBell, IconUser } from '@tabler/icons-react';
import { useAuth } from '../../context/AuthContext';

interface NavItemProps {
  icon: React.ReactNode;
  label: string;
  to: string;
  active?: boolean;
}

function NavItem({ icon, label, to, active }: NavItemProps) {
  return (
    <UnstyledButton
      component={Link}
      to={to}
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0.5rem',
        color: active ? 'var(--mantine-color-brand-filled)' : 'inherit',
      }}
    >
      <Stack gap={2} align="center">
        {icon}
        <Text size="xs" fw={active ? 600 : 400}>
          {label}
        </Text>
      </Stack>
    </UnstyledButton>
  );
}

export function MobileBottomNav() {
  const location = useLocation();
  const { isAuthenticated, user } = useAuth();

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Box
      component="nav"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'var(--mantine-color-body)',
        borderTop: '1px solid var(--mantine-color-default-border)',
        zIndex: 100,
      }}
    >
      <Text size="xs" c="dimmed" ta="center" py={2} px="xs" style={{ fontSize: 9 }}>
        As an Amazon Associate I earn from qualifying purchases.
      </Text>
      <Divider />
      <Box style={{ display: 'flex', alignItems: 'center', height: 60 }}>
      <NavItem
        icon={<IconHome size={24} stroke={1.5} />}
        label="Home"
        to="/"
        active={isActive('/')}
      />
      <NavItem
        icon={<IconSearch size={24} stroke={1.5} />}
        label="Search"
        to="/search"
        active={isActive('/search')}
      />
      {isAuthenticated ? (
        <>
          <NavItem
            icon={
              <Box
                style={{
                  width: 44,
                  height: 44,
                  borderRadius: '50%',
                  backgroundColor: 'var(--mantine-color-brand-filled)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <IconPlus size={24} color="white" />
              </Box>
            }
            label=""
            to="/reviews/create"
            active={false}
          />
          <NavItem
            icon={<IconBell size={24} stroke={1.5} />}
            label="Alerts"
            to="/notifications"
            active={isActive('/notifications')}
          />
          <NavItem
            icon={<IconUser size={24} stroke={1.5} />}
            label="Profile"
            to={`/users/${user?.username}`}
            active={location.pathname === `/users/${user?.username}`}
          />
        </>
      ) : (
        <>
          <NavItem
            icon={<IconUser size={24} stroke={1.5} />}
            label="Log in"
            to="/login"
            active={isActive('/login')}
          />
        </>
      )}
      </Box>
    </Box>
  );
}
